/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

import React from "react";
import { useTranslation } from "react-i18next";

import { usePreviewMode } from "../../hooks/usePreviewMode";

import "./AppPreviewMode.scss";

export const AppPreviewMode = () => {
  const { previewMode, exitPreviewMode } = usePreviewMode();
  const { t } = useTranslation();

  if (!previewMode) {
    return null;
  }

  return (
    <section className="AppPreviewMode">
      {t("APP_PREVIEW_MODE_MESSAGE")}
      <button
        className="AppPreviewMode__ExitPreviewMode"
        onClick={exitPreviewMode}
      >
        {t("APP_PREVIEW_MODE_BUTTON_EXIT")}
      </button>
    </section>
  );
};
